module.exports = __webpack_public_path__ + "static/media/dagger.e81f075c.svg";